<template>
	<div class="Header BoxD">
		<div class="main header_top cf">
			<a href="javascript:;" class="logo fl">
				<img src="../assets/index_logo.png"  title="">
			</a>
			<h2>用户登录</h2>
			<!-- <div class="HeadNav fr mt25">
				<a href="javascript:;">首页</a><a href="javascript:;">网校</a><a href="javascript:;">题库</a><a
					href="javascript:;">APP</a>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Header1',

	}
</script>

<style>
	@import "../assets/css/model.css";

	
</style>